module.exports = __webpack_public_path__ + "img/Ranger.9ab96fb5.png";